import { Box, styled } from "@mui/material";

import { tintColor } from "@/theme/colors";

export const Content = styled(Box)`
  display: flex;
  min-height: calc(100vh - 76px);
  max-width: 100vw;
`;

export const PageContainer = styled(Box)(
  ({ theme }) => `
  background-color: ${tintColor};
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${theme.spacing(4)} ${theme.spacing(6)};

  @media (max-width: 960px) {
    padding: ${theme.spacing(2)};
    max-width: 100%;
  }
`,
);
